(function($){

	/* Get accurate Viewport sizing (no jQuery) */
    var viewportwidth;
    var viewportheight;

    function getWindowSize(){
        if (typeof window.innerWidth != 'undefined'){
            viewportwidth = window.innerWidth,
            viewportheight = window.innerHeight
        }else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0){
            viewportwidth = document.documentElement.clientWidth,
            viewportheight = document.documentElement.clientHeight
        }else{
            viewportwidth = document.getElementsByTagName('body')[0].clientWidth,
            viewportheight = document.getElementsByTagName('body')[0].clientHeight
        }
    }

    
    function initSlider() {
        $('.slider').slick({
            dots: true,
            arrows: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true,
        });
    }


    /*
     *
     * Equal Height jQuery Snippet.  Using this for footer and grid accordion
     *
     */
    var equalheight = function (container){

        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = [],
            $el,
            topPosition = 0,
            currentDiv;
    
        $(container).each(function () {

            $el = $(this);
            $el.height('auto');
            topPosition = $el.position().top;

            if (currentRowStart < topPosition - 1 || currentRowStart > topPosition + 1) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs = [];
                currentRowStart = topPosition;
                currentTallest = $el.height();
                rowDivs.push($el);
            }
            else {
                rowDivs.push($el);
                currentTallest = Math.max(currentTallest, $el.height());
            }
        });
        
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].css('height', currentTallest);
        }
    };


    /* YOUTUBE VIDEO EMBED */
    var $video_icon = $('.video_icon');
    if ($video_icon.length) {
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        $video_icon.on("click", function() {
            var $this = $(this),
                $youtube_id = $(this).data('youtubeid'),
                $video_id = $(this).data('videoid'),
                $parent = $(this).parents('.video_parent');
            $this.fadeOut(300);
            player = new YT.Player($video_id, {
                videoId: $youtube_id,
                height: $parent.outerHeight(),
                width: $parent.outerWidth(),
                playerVars: {rel: 0},
                events: {
                    'onReady' : onPlayerReady
                }
            });

        });
    }

    function onPlayerReady(event) {
        event.target.playVideo();
    }


    /* Side Navigation Toggle */
    function sideNavTabs(){
        if ($('.side_navigation').length) {
            $('.side_navigation .expand-menu').on('click', function() {
                $('.side_navigation').toggleClass('expanded');
                //$('.side_navigation ul ul').slideToggle();
            });
        }
    }

	/* Document Ready */
	$(document).ready(function() {
		getWindowSize();
        equalheight('.equal-height');

        initSlider();

        sideNavTabs();

        //Sidr
        $('#mobile-trigger').sidr({
            name: 'sidr',
            side: 'right',
            source : function() {
                return '<div id="mobile-menu"><span class="sidr__close">Close Navigation</span><div class="sidr__inner">' + $('#site-navigation').html() + '</div></div>';
            }
        });
        $('.menu-item-has-children .arrow').click(function(e) {
            e.preventDefault();
            $(this).next().slideToggle();
        });
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
        });

        $('.accordion_tabs .tabs_heading').each(function() {

            var $this = $(this);

            // create unique id for a11y relationship
            var id = 'accordion-' + $this.index();

            // Add the button inside the <h2> so both the heading and button semanics are read
            var prev_expanded_accordian = cookie.get( 'curriculum_expanded','');
            var prev_state = prev_expanded_accordian === id ? true : false;

            // wrap the content and make it focusable
            $this.nextUntil('.tabs_heading').wrapAll('<div id="'+ id +'" aria-hidden="'+!prev_state+'">');
            var panel = $this.next();

            $this.wrapInner('<button aria-expanded="'+prev_state+'" aria-controls="'+ id +'" class="tabs_button">');
            var button = $this.children('button');

            // Toggle the state properties
            button.on('click', function() {
                var state = $(this).attr('aria-expanded') === 'false' ? true : false;
                $(this).attr('aria-expanded', state);
                panel.attr('aria-hidden', !state);

                //maintain state in cookie in case leaving page
                var expanded_accordian = $(this).attr('aria-controls')
                cookie.set( 'curriculum_expanded', expanded_accordian);
                if(state === false){
                  cookie.set( 'curriculum_expanded', ''); 
                }
            });

        });

	});

	$(window).on("resize", function() {
		getWindowSize();
        equalheight('.equal-height');

        if($('body').hasClass('sidr-open') && $(window).width() >= 1024) {
            $.sidr('close');
        }

	});

    $(".faq_question").click(function() {
        var faqId = $(this).data('id');

        var  arrowI = $(this).find( "i" );
        if (arrowI.hasClass('fa-angle-right')){
            arrowI.removeClass('fa-angle-right');
            arrowI.addClass('fa-angle-down');
        }else{
            arrowI.removeClass('fa-angle-down');
            arrowI.addClass('fa-angle-right');
        }

        $('.faq_answer[data-id=' + faqId + ']').toggle();
        $('.faq_block').removeClass('faq_expanded');    
        if($('.faq_answer[data-id=' + faqId + ']').is(":visible")){
            $(this).parent('div').addClass('faq_expanded');
        }
    });


    window.addEventListener("orientationchange", function() {
        // Announce the new orientation number
        equalheight('.equal-height');
    }, false);

})(jQuery);